<script>
import { RectangleStencil } from 'vue-advanced-cropper';

export default {
  name: 'StarStencil',
  extends: RectangleStencil,
  methods: {
    aspectRatios() {
      const max = 100;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
    processCrop(canvas) {
      const context = canvas.getContext('2d');
      const { width } = canvas;
      const { height } = canvas;
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.scale(1, height / width);
      // This path's size is 1235x1175. Calculating this is not easy, so we just have to know beforehand
      const pathSize = { w: 1235, h: 1175 };
      const starPath = new Path2D('M0,449h1235l-999,726 382-1175 382,1175z');
      const starPathScaled = new Path2D();
      const matrix = document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGMatrix();
      starPathScaled.addPath(starPath, matrix.scaleNonUniform(width / pathSize.w, width / pathSize.h));
      context.fill(starPathScaled);
      context.closePath();
      return canvas;
    },
  },
};
</script>
<style scoped lang="scss">

$border-radius: 50% 50% 0 0;
.vue-rectangle-stencil {
  ::v-deep &__preview {
    clip-path: polygon(50% 0%, 63% 38%, 100% 38%, 69% 59%, 82% 100%, 50% 75%, 18% 100%, 31% 59%, 0 38%, 37% 38%);
  }
}

</style>
